import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiError } from '../error-handling/error.models';
import { ErrorHandlingService } from '../error-handling/error-handling.service';

@Injectable({
    providedIn: 'root',
})
export class FormDataApiService {
    private baseUrl: string = environment.apiUrl + '/api/';
    private baseUrlMedia: string = environment.apiUrl;

    constructor(
        private http: HttpClient,
        private errorHandlingService: ErrorHandlingService
    ) { }

    create(apiName: string, data: any, context?: HttpContext): Observable<any | ApiError> {
        const formData = this.buildFormData(data);
        return this.http
            .post<any>(`${this.baseUrl}${apiName}`, formData, { context })
            .pipe(catchError(this.handleError));
    }

    update(apiName: string, id: string, data: any): Observable<any | ApiError> {
        const formData = this.buildFormData(data);
        return this.http
            .patch<any>(`${this.baseUrl}${apiName}/${id}`, formData)
            .pipe(catchError(this.handleError));
    }

    downloadFile(url: string): Observable<Blob> {
        // Si l'URL est déjà absolue, l'utiliser directement
        const fullUrl = url.startsWith('http') ? url : `${this.baseUrlMedia}${url}`;

        return this.http.get(fullUrl, {
            responseType: 'blob',
            headers: new HttpHeaders({
                'Accept': 'application/octet-stream'
            })
        }).pipe(
            catchError(this.handleError)
        );
    }


    private buildFormData(input: any): FormData {
        const formData = new FormData();
        Object.keys(input).forEach((key) => {
            const value = input[key];

            if (value instanceof File) {
                formData.append(key, value);
            } else if (Array.isArray(value)) {
                value.forEach((v, i) => {
                    formData.append(`${key}[${i}]`, v);
                });
            } else if (typeof value === 'object' && value !== null) {
                formData.append(key, JSON.stringify(value));
            } else if (value !== null && value !== undefined) {
                formData.append(key, value);
            }
        });
        return formData;
    }

    private handleError = (error: HttpErrorResponse): Observable<never> => {
        const apiError = this.errorHandlingService.handleError(error);
        return throwError(() => apiError);
    };
}
